// removed by extract-text-webpack-plugin
module.exports = {"OffersFilters":"OffersFilters__OffersFilters___1Z44X","OffersFiltersLabel":"OffersFilters__OffersFiltersLabel___2hWKf","OffersFiltersTabletClose":"OffersFilters__OffersFiltersTabletClose___xFW7V","OffersFiltersTabletUpdate":"OffersFilters__OffersFiltersTabletUpdate___2qY2K","OffersFiltersTablet":"OffersFilters__OffersFiltersTablet___2lX47"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/OffersFilters/OffersFilters.less
// module id = 1193
// module chunks = 0 1